<!-- <h4 class="h4">(Personnel)</h4> -->
<div *ngIf="isLoading" class="overlay">
  <div class="spinner"></div>
</div>
<div class="main-content div__main">
  <div class="container-fluid p-0">
    <div class="row justify-content-center">
      <div
        class="col-4 col-md-2"
        *ngFor="let card of resumenCardsTwo; index as i"
      >
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 1 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 1, 'text-white': i !== 1 }"
                >
                  <!-- {{ card.value }} -->
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 1 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-5">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="card-tools">
          <a
            [routerLink]="['/numbers/accounting']"
            class="btn btn-dark btn-sm btn-new"
            [ngClass]="{ 'btn-selected': step === 1 }"
          >
            Staff
          </a>
          <a
            [routerLink]="['/numbers/accounting/freelancers']"
            class="btn btn-dark btn-sm btn-new"
            [ngClass]="{ 'btn-selected': step === 2 }"
          >
            Freelancers
          </a>
          <a
            [routerLink]="['/numbers/accounting/drivers']"
            class="btn btn-dark btn-sm btn-new"
            [ngClass]="{ 'btn-selected': step === 3 }"
          >
            Driver & +
          </a>
          <a
            [routerLink]="['/numbers/accounting/customers']"
            class="btn btn-dark btn-sm btn-new"
            [ngClass]="{ 'btn-selected': step === 4 }"
          >
            Customers
          </a>
          <a
            [routerLink]="['/numbers/accounting/quickbooks/expenses']"
            class="btn btn-dark btn-sm btn-new"
          >
            Bills
          </a>
          <!-- <a
            (click)="pru()"
            class="btn btn-dark btn-sm btn-new"
          >
            pru
          </a> -->
        </div>
        <div class="card">
          <div class="card-header card-header-icon d-flex align-items-center">
            <div class="card-icon">
              <!-- <i class="material-icons">perm_identity</i> -->
              <img
                class="img--icon"
                [src]="userImgUrl"
                (click)="openModalImg('imgUser')"
              />
            </div>
            <h4 class="card-title mb-0 me-3 flex-grow-1">{{ fullname }}</h4>
            <div class="ms-auto">
              <i
                class="fas fa-edit text-dark icon__edit"
                (click)="enableUpdate()"
              ></i>
            </div>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <!-- Información Básica -->
              <div class="row" *ngIf="this.form.get('business_name')?.value">
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="business_name"
                      >Business name</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="business_name"
                      formControlName="business_name"
                      [readOnly]="id"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('business_name')"
                    >
                      The business_name is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="firstname"
                      >Name</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="firstname"
                      formControlName="firstname"
                      [readOnly]="id"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('firstname')"
                    >
                      The name is required
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="lastname"
                      >Last Name</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="lastname"
                      formControlName="lastname"
                      [readOnly]="id"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('lastname')"
                    >
                      The last name is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="username"
                      >Email</label
                    >
                    <div class="d-flex">
                      <input
                        type="text"
                        class="form-control"
                        id="username"
                        formControlName="username"
                        [readOnly]="id"
                      />
                      <button
                        class="btn btn-sm btn-outline-dark"
                        type="button"
                        (click)="openEmail(form.get('username')?.value)"
                        title="Send email"
                      >
                        <i class="fas fa-envelope"></i>
                      </button>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('username')"
                      >
                        The email is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="title">Title</label>
                    <input
                      type="text"
                      class="form-control"
                      id="title"
                      formControlName="title"
                      [readOnly]="id"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('title')"
                    >
                      The title is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <!-- <div class="col-6">
                  <label for="paymentAccountId">Account Type</label>
                  <select
                    class="form-control select"
                    id="paymentAccountId"
                    formControlName="paymentAccountId"
                    [ngClass]="{ disabled__select: !update }"
                  >
                    <option value="" disabled>Select</option>
                    <option
                      *ngFor="let item of paymentAccounts"
                      [value]="item.Id"
                    >
                      {{ item.Name }}
                    </option>
                  </select>
                </div> -->
                <div class="col-3 col-md-3">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="dueDate">Date</label>
                    <input
                      type="date"
                      class="form-control"
                      id="dueDate"
                      formControlName="dueDate"
                      [readOnly]="!update"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('dueDate')"
                    >
                      dueDate is required
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="row">
                <div class="col-12 col-md-12">
                  <div formArrayName="lines">
                    <div
                      *ngFor="let line of lines.controls; let i = index"
                      [formGroupName]="i"
                      class="row mb-2"
                    >
                      <div class="col-3">
                        <label for="amount">Amount</label>
                        <input
                          type="number"
                          class="form-control"
                          formControlName="amount"
                          [readOnly]="!update"
                        />
                      </div>

                      <div class="col-9">
                        <label for="description">Description</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder=""
                          formControlName="description"
                          [readOnly]="!update"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->

              <div class="row">
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="value">Salary</label>
                    <input
                      type="number"
                      class="form-control"
                      id="value"
                      formControlName="value"
                      readOnly
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('value')"
                    >
                      Value is required
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="frequency"
                      >Frequency</label
                    >
                    <select
                      class="form-control select"
                      id="frequency"
                      formControlName="frequency"
                      [ngClass]="{ disabled__select: !update }"
                    >
                      <option value="">Select a frequency</option>
                      <option
                        *ngFor="let item of frequencies"
                        [value]="item.code"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('frequency')"
                    >
                      Frequency is required
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <div class="custom-control custom-switch mt-4 text-center">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="status"
                        formControlName="status"
                      />
                      <label class="custom-control-label" for="status"
                        >Active</label
                      >
                    </div>
                  </div>
                </div>
              </div> -->

              <div class="row text-center">
                <div class="col-12">
                  <button
                    type="submit"
                    class="btn btn-dark pull-right btn-update"
                    [disabled]="form.invalid"
                  >
                    {{ id ? "Update" : "Create" }}
                  </button>
                </div>
              </div>

              <div class="clearfix"></div>

              <!--  <div class="row mt-5">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="comments"
                      >Comments</label
                    >
                    <textarea
                      type="text"
                      class="form-control"
                      id="comments"
                      formControlName="comments"
                      rows="2"
                      [readOnly]="!update"
                    ></textarea>
                  </div>
                </div>
              </div> -->
            </form>
            <!-- Modal imgs-->
            <div
              class="modal fade"
              tabindex="-1"
              [ngClass]="{ 'show d-block': showModalImg }"
              style="background-color: rgba(0, 0, 0, 0.5)"
            >
              <!-- style="background-color: rgba(0,0,0,0.5);" -->
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header modal-close">
                    <button
                      type="button"
                      class="btn btn-link btn-sm btn-close"
                      (click)="closeModalImg()"
                    >
                      &times;
                    </button>
                  </div>
                  <div class="modal-body text-center">
                    <img [src]="imgModal" class="modal--imgs" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-4">
        <div class="card card-profile">
          <div class="card-avatar"></div>
          <div class="card-body">
            <h6 class="card-category text-gray">User profile</h6>
            <h4 class="card-title">
              {{ form.get("firstname")?.value }}
              {{ form.get("lastname")?.value }}
            </h4>
            <p class="card-description">
                Aquí puedes editar los datos del usuario. Los cambios se
                reflejarán en el sistema.
              </p>
            <a href="#pablo" class="btn btn-rose btn-round">Ver perfil</a>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>
